<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="用户名：">
          <el-input v-model="searchValue.username"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="searchBlackUserList"
            >查询</el-button
          >
          <el-button type="success" plain @click="addBlackUserDialog"
            >新增黑名单</el-button
          >
          <el-button :loading="inputLoading" type="warning" plain @click="$refs.importCsv.click()"
            >批量导入</el-button
          >
          <el-button type="success" plain @click="$refs.template.click()"
            >下载导入模板</el-button
          >
          <a ref="template" :href="template" download="用户黑名单批量导入模板.xlsx" style="display: none;"></a>
          <input style="display:none" @change="csvChange" type="file" id="importCsv" ref="importCsv" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
        </el-form-item>
      </el-form>
    </div>
    <!-- phone黑名单列表展示 -->
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="username" label="用户名"> </el-table-column>
      <el-table-column prop="real_name" label="实名"> </el-table-column>
      <el-table-column prop="last_login_at" label="最后登录时间"> </el-table-column>
      <el-table-column prop="id_card" label="身份证"> </el-table-column>
      <el-table-column label="备注">
        <template slot-scope="scope">
          <span>{{getReason(scope.row.status_reason)}}</span>
        </template>
      </el-table-column>
      <el-table-column label="全局禁用">
        <template slot-scope="scope">
          <span>{{scope.row.is_overall ? '是' : '否'}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="danger" plain @click="del_blackUser(scope.row.id)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>

    <!-- 添加黑名单弹出框 -->
    <el-dialog
      title="添加黑名单"
      :visible.sync="addDialogFormVisible"
      width="28%"
      class="addBlack"
    >
      <el-form>
        <el-form-item label="用户名:">
          <el-input v-model="username"></el-input>
        </el-form-item>
        <el-form-item label="备注:">
          <el-select
            v-model="remark"
            placeholder="请选择封禁原因/解封原因"
          >
            <el-option
              v-for="item in reasonsList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="全局禁用：">
          <el-switch
            v-model="is_overall"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addBlackUserSubmit()"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import XLSX from 'xlsx'
import template from './template.xlsx'

export default {
  name: "blackUser",
  components: {},
  data() {
    return {
      loadingData: false,
      addDialogFormVisible: false,
      searchValue: {
        username: "",
      },
      historyValue: "",
      tableHeight: 0,
      tableData: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 10,
      username: "",
      remark: "",
      is_overall: 0,
      inputLoading: false,
      template,
      reasonsList: [],
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.getBlackUserList(true)
    this.reasons()
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    getReason (reason_id) {
      const reason =  this.reasonsList.find(({id}) => id === reason_id)
      return reason ? reason.name : '--'
    },
    reasons() {
      fetch({
        url: "/admin/users/status_reason",
        method: "GET",
      }).then((res) => {
        this.reasonsList = res.data.data;
      });
    },
    csvChange () {
      const file = this.$refs.importCsv.files && this.$refs.importCsv.files[0]
      if (file) { 
        const reader = new FileReader()
        reader.readAsBinaryString(file)
        reader.onload = async (e) => {
          let keyConfig = {
            '用户名': 'username',
            '备注': 'remark',
            '全局禁用': 'is_overall'
          }
          let dataList = {}
          let keyList = {}
          let remark = null
          let is_overall = 0
          const csv = XLSX.read(e.target.result, {type: 'binary'})
          if (csv && csv.SheetNames && csv.SheetNames.length && csv.Sheets) {
            const sheet = csv.Sheets[csv.SheetNames[0]]
            for (let key in sheet) {
              const code = key.replace(/[^A-Z]/g, '')
              const index = key.replace(/[^0-9]/g, '')
              const value = sheet[key] && sheet[key].v
              if (index === '1') {
                keyList[code] = keyConfig[value]
              } else if (index) {
                if (!dataList[index]) dataList[index] = {}
                if (keyList[code]) {
                  let val = sheet[key] && sheet[key].v
                  dataList[index][keyList[code]] = val
                  if (index === '2' && keyList[code] === 'remark') {
                    remark = this.reasonsList?.find(({name}) => name === val)?.id
                  }
                  if (index === '3' && keyList[code] === 'is_overall') {
                    is_overall = val === '是' ? 1 : 0
                  }
                }
              }
            }
            let list = []
            this.inputLoading = true
            for (let data in dataList) {
              list.push(dataList[data])
            }
            await fetch({
              url: "/admin/black_users/add",
              method: "POST",
              data: {
                username: list.map(({username}) => username).toString(),
                remark,
                is_overall,
              },
            }).then((res) => {
              if (res.data.status) {
                this.$message({
                  type: "success",
                  message: "批量新增黑名单成功！",
                });
                this.getBlackUserList();
              } else {
                this.$message.error(res.data.message);
              }
            }).finally(() => this.inputLoading = false)
          }
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getBlackUserList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getBlackUserList(false);
    },
    // 实现游戏数据搜索
    searchBlackUserList() {
      this.currentPage = 1;
      this.getBlackUserList(true);
    },
    // 删除
    del_blackUser(id) {
      this.$confirm("是否确定删除该数据?", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.del_blackUserSubmit(id);
        })
        .catch(() => {});
    },
    del_blackUserSubmit(id) {
      fetch({
        url: "/admin/black_users/delete",
        method: "GET",
        params: {
          id: id,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.getBlackUserList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 新增黑名单
    addBlackUserDialog() {
      this.username = "";
      this.remark = ""
      this.is_overall = 0
      this.addDialogFormVisible = true;
    },
    // 新增黑名单提交操作
    addBlackUserSubmit() {
      fetch({
        url: "/admin/black_users/add",
        method: "POST",
        data: {
          username: this.username,
          remark: this.remark,
          is_overall: this.is_overall,
        },
      }).then((res) => {
        if (res.data.status) {
          this.$message({
            type: "success",
            message: "新增黑名单成功！",
          });
          this.addDialogFormVisible = false;
          this.getBlackUserList();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    // 展示phone拉黑列表数据
    getBlackUserList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      fetch({
        url: "/admin/black_users/list",
        method: "GET",
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          ...searchValue
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
a {
  text-decoration: none;
  color: #606266;
}
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.addBlack {
  .el-form-item {
    display: flex;
    // justify-content: center;
    .el-input {
      width: 320px;
    }
  }
}
</style>
